var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9062 10.3743L20.7657 12.5L18.9062 14.6257L19.1653 17.4371L16.4143 18.0619L14.9739 20.4924L12.3829 19.38L9.79179 20.5L8.35147 18.0695L5.60036 17.4448L5.85947 14.6257L4 12.5L5.85947 10.3667L5.60036 7.54762L8.35147 6.93048L9.79179 4.5L12.3829 5.61238L14.9739 4.5L16.4143 6.9381L19.1653 7.56286L18.9062 10.3743ZM9.12069 12.1043L9.16976 12.0762L9.15927 12.0657L9.12069 12.1043Z",
    fill: "#65A8EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2863 14.2872L9.4992 12.5001L8.89062 13.1044L11.2863 15.5001L16.4292 10.3572L15.8249 9.75293L11.2863 14.2872Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCheckmark);
export default __webpack_public_path__ + "static/media/verified-checkmark.72b9fe20d25d34b016bd3c25bdc5283d.svg";
export { ForwardRef as ReactComponent };